// extracted by mini-css-extract-plugin
export default {"time-slot-row":"CalendarGrid_time-slot-row__QwHjX","calendar-grid":"CalendarGrid_calendar-grid__GnieU"};